import { orpc } from '@client-info/utils/orpc';
import type { QueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { queryKey } from '../../features/areYouOk/hooks';
import { mapToChannel } from './-utils/mapToChannel';

type LoadParams = { id: string; channel: string };

export const load = (
  { id, channel: channelShort }: LoadParams,
  queryClient: QueryClient,
) => {
  const channel = mapToChannel(channelShort);
  orpc.areYouOk.setOpened.call({ id, channel }).catch(() => {});
  return queryClient
    .ensureQueryData(
      orpc.areYouOk.byId.queryOptions({
        queryKey: [...queryKey, id],
        input: { id },
      }),
    )
    .catch(() => {
      throw new Error('Error loading are you ok');
    });
};

export const Route = createFileRoute('/safety-check/$channel/$id')({
  loader: ({ params, context: { client: queryClient } }) =>
    load(params, queryClient),
});
